import React, { FC, useMemo } from "react";

import groupBy from "lodash-es/groupBy";

import { GuideStatus } from "@mapmycustomers/shared";
import { GuideUserStatus } from "@mapmycustomers/shared/types/entity";
import User from "@mapmycustomers/shared/types/User";

import UserStats from "../stats/UserStats";

import styles from "./UsersStats.module.scss";

export interface GuidesStatsProps {
  users: User[];
  usersStatusMap: Record<User["id"], GuideUserStatus[]>;
}

const UsersStats: FC<GuidesStatsProps> = ({ users, usersStatusMap }) => {
  const { completed, notStarted, partiallyComplete, unassigned } = useMemo(() => {
    return users.reduce(
      (result, user) => {
        if (user.id in usersStatusMap) {
          const statuses = usersStatusMap[user.id];
          const groups = groupBy(statuses, "status") as Partial<
            Record<GuideStatus, GuideUserStatus[]>
          >;
          if (groups[GuideStatus.COMPLETED]?.length === statuses.length) {
            result.completed++;
          } else if (groups[GuideStatus.NOT_STARTED]?.length == statuses.length) {
            result.notStarted++;
          } else {
            result.partiallyComplete++;
          }
        } else {
          result.unassigned++;
        }
        return result;
      },
      { completed: 0, notStarted: 0, partiallyComplete: 0, unassigned: 0 }
    );
  }, [usersStatusMap, users]);

  return (
    <div className={styles.container}>
      <UserStats className={styles.item} count={completed} total={users.length} type="completed" />
      <UserStats
        className={styles.item}
        count={partiallyComplete}
        total={users.length}
        type="partiallyComplete"
      />
      <UserStats
        className={styles.item}
        count={notStarted}
        total={users.length}
        type="notStarted"
      />
      <UserStats
        className={styles.item}
        count={unassigned}
        total={users.length}
        type="unassigned"
      />
    </div>
  );
};

export default UsersStats;
